import { render } from "./TunggakanMengikutTanah.vue?vue&type=template&id=53710a5c"
import script from "./TunggakanMengikutTanah.vue?vue&type=script&lang=js"
export * from "./TunggakanMengikutTanah.vue?vue&type=script&lang=js"

import "./TunggakanMengikutTanah.vue?vue&type=style&index=0&id=53710a5c&lang=css"
import "./TunggakanMengikutTanah.vue?vue&type=style&index=1&id=53710a5c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__